import React, { useEffect } from "react";
const { kakao } = window;

function KakaoMap(x, y, mapId) {

  useEffect(() => {
    var mapContainer = document.getElementById(mapId), // 지도를 표시할 div 
      mapOption = {
        center: new kakao.maps.LatLng(x, y), 
        level: 3 
      };

    var map = new kakao.maps.Map(mapContainer, mapOption); 

    var markerPosition = new kakao.maps.LatLng(x, y);

    var marker = new kakao.maps.Marker({
      position: markerPosition
    });

    marker.setMap(map);
  }, [])

  return (
    <>
      <div id={mapId}></div>
    </>
  )
}

export default KakaoMap;